import actions from './actions'
import mutations from './mutations'

const state = function () {
  return {
    branches: [],
    currentBranch: null,
    currentMove: null,
    primaryBranch: null
  }
}

const getters = {
  revisionHistoryBranches: (state) => state.branches,
  revisionHistoryCurrentBranch: (state) => state.currentBranch,
  revisionHistoryCurrentMove: (state) => state.currentMove,
  revisionHistoryPrimaryMove: (state) => {
    const pb = state.primaryBranch
    const hasPrimaryBranchHistory = pb && pb.histories
    const hasARevision = hasPrimaryBranchHistory && pb.histories.length > 0
    if (hasARevision) {
      return pb.histories[0]
    } else {
      return null
    }
  }
}

const module = {
  state,
  getters,
  actions,
  mutations
}

export default module



// WEBPACK FOOTER //
// ./src/app/appLogic/revisionHistory/store/index.js